import React, { useEffect } from 'react';

import Navbar from '../components/Navbar';
import FadeCarousel from '../components/FadeCarousel';
import SearchBar from '../components/SearchBar';
import Movies from '../components/Movies';
import FooterBar from '../components/FooterBar';
import Loader from '../components/Loader';
import Toast from '../components/Toast';
import { GlobalStyle } from '../GlobalStyles';

import { useGlobalContext } from '../Context';

const HomePage = () => {
  const {
    movies,
    trending,
    isLoading,
    heroHome,
    trailers,
    showToast,
    setShowToast,
    addToList,
  } = useGlobalContext();

  useEffect(() => {
    setShowToast({
      heading: '',
      msg: '',
      isShowing: false,
    });
  }, [setShowToast]);

  if (isLoading) {
    return (
      <div className='app-wrapper'>
        <Navbar />
        <SearchBar />
        <Loader />
        <FooterBar />
        <GlobalStyle />
      </div>
    );
  }

  return (
    <div className='app-wrapper'>
      <Navbar />
      <FadeCarousel heroData={heroHome} addToList={addToList} />
      {/* searchbar */}
      <SearchBar />
      {/* popular movies */}
      <Movies rowtitle={'Popular'} movies={movies} />
      {/* my list */}
      <Movies rowtitle={'Trending'} movies={trending} classes={'dark'} />
      {/* trailers */}
      <FadeCarousel heroData={trailers} addToList={addToList} />
      {/* Footer */}
      <FooterBar />

      {showToast.isShowing && (
        <Toast heading={showToast.heading} message={showToast.msg} />
      )}
      <GlobalStyle />
    </div>
  );
};

export default HomePage;
